import React from 'react';

const RadioButton = ({ children, name, value, activeValue, onChange, ...otherProps }) => (
    <label className={`radio-button${value === activeValue ? ' radio-button-active' : ''}`} htmlFor={`${name}-${value}`} {...otherProps}>
        <input id={`${name}-${value}`} type="radio" name={name} checked={value === activeValue} value={value} onChange={onChange} />
        <div className="radio-button-input" />
        <div className="radio-button-content">{children}</div>
    </label>
);

export default RadioButton;
